<script lang="ts">
import { computed } from 'vue';
import type { NavigationNode } from '../../../../types/link';
import Button1XP from '../../../Button1XP/Button1XP.vue';
import { isTabletOrMobile } from '../../../../utils/breakpoints.js';

type Props = {
  items: NavigationNode[];
};
</script>

<script setup lang="ts">
const props = defineProps<Props>();

const visibleItems = computed(() => {
  return props.items.filter((item) => !item.hideInNavigation);
});

const sortedItems = (items: NavigationNode[]) => {
  if (items) {
    return items.sort((a, b) => (a.position || 0) - (b.position || 0));
  }
};
</script>

<template>
  <div :class="$style.container">
    <nav v-if="visibleItems[0]?.children" :aria-label="visibleItems[0]?.label">
      <Button1XP
        v-for="item in sortedItems(visibleItems[0]?.children)"
        :key="item._id"
        :size="isTabletOrMobile ? 's' : 'xs'"
        :target="item.newWindow ? '_blank' : '_self'"
        :text="item.label"
        :url="item.url"
        :variant="item.variant"
      />
    </nav>
  </div>
</template>

<style module scoped lang="scss" src="./Meta.scss" />
